/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.WaitList {
    angular.module("meevo.plugins.waitList", []);
}
